import { render, staticRenderFns } from "./electricChargeAdd.vue?vue&type=template&id=567bb6f0&scoped=true"
import script from "./electricChargeAdd.vue?vue&type=script&lang=js"
export * from "./electricChargeAdd.vue?vue&type=script&lang=js"
import style0 from "./electricChargeAdd.vue?vue&type=style&index=0&id=567bb6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567bb6f0",
  null
  
)

export default component.exports